import { createReducer } from './util';
import { PLAN_LIST_ADD_PRODUCT, PLAN_LIST_REDUCE_PRODUCT, PLAN_LIST_REMOVE_PRODUCT, PLAN_LIST_CLEAR_PRODUCT, PLAN_LIST_MODIFY_PRODUCT, RESTORE_PLAN_LIST, } from '../constants';
import state from '../state';
import { accAdd, accSub } from '../../util/math';

function modifyProductNum(state, updateProducts, init) {
  const { products, ids, cartIds, sellers, sellerIds } = state;
  let newSellerIds = [...sellerIds];
  let newIds = [...ids];
  let newCartIds = [...cartIds];
  let newSellers = Object.assign({}, sellers);
  let newProducts = Object.assign({}, products);

  if (init) {
    newSellerIds = [];
    newIds = [];
    newCartIds = [];
    newSellers = [];
    newProducts = [];
  }

  updateProducts.forEach((product) => {
    const { num, normsId, sellerId, sellerName, cartId, can_check } = product;
    if (num > 0) {
      if (!newSellers[sellerId]) {
        newSellers[sellerId] = {
          id: sellerId,
          name: sellerName,
          productIds: [],
        };
        newSellerIds.push(sellerId);
      }
      if (!newProducts[normsId]) {
        newProducts[normsId] = Object.assign({}, product, { num });
        can_check && newIds.push(normsId);
        newCartIds.push(cartId);
        newSellers[sellerId].productIds.push(normsId);
      } else {
        newProducts[normsId] = Object.assign({}, newProducts[normsId], { num });
      }
    } else {
      if (!newSellers[sellerId] || !newProducts[normsId]) {
        return;
      }
      let index = newSellers[sellerId].productIds.indexOf(normsId);
      newSellers[sellerId].productIds.splice(index, 1);
      if (newSellers[sellerId].productIds.length === 0) {
        delete newSellers[sellerId];
        let index = newSellerIds.indexOf(sellerId);
        newSellerIds.splice(index, 1);
      }
      delete newProducts[normsId];
      newIds.splice(newIds.indexOf(normsId), 1);
      newCartIds.splice(newCartIds.indexOf(cartId), 1);
    }
  });
  return {
    products: newProducts,
    ids: newIds,
    cartIds: newCartIds,
    sellers: newSellers,
    sellerIds: newSellerIds,
  };
}

function addProduct(state, action) {
  const { product, count } = action;
  const { products } = state;
  return modifyProductNum(state, [
    Object.assign(product, {
      num: products[product.normsId] ? accAdd(products[product.normsId].num, count) : count,
    }),
  ]);
}
function reduceProduct(state, action) {
  const { product } = action;
  const { products } = state;
  return modifyProductNum(state, [
    Object.assign(
      product,
      {
        num: products[product.normsId] ? accSub(products[product.normsId].num, 1) : 0,
      }
    ),
  ]);
}
function clearProduct() {
  return {
    products: {},
    ids: [],
    cartIds: [],
    sellers: {},
    sellerIds: [],
  };
}
function removeProduct(state, action) {
  const { normsId } = action;
  const { products } = state;
  const normsIds = Array.isArray(normsId) ? normsId : [normsId];
  let array = [];

  normsIds.forEach((normsId) => {
    normsId = Number(normsId);
    array.push(Object.assign({}, products[normsId], {
      normsId,
      num: 0,
    }));
  });
  return modifyProductNum(state, array);
}
function modifyProduct(state, action) {
  const { product, num } = action;
  return modifyProductNum(state, [
    Object.assign(product, {
      num,
    }),
  ]);
}
function initPlanList(state, action) {
  const { products } = action;
  return modifyProductNum(state, products, true);
}
export default createReducer(
  {
    [PLAN_LIST_ADD_PRODUCT]: addProduct,
    [PLAN_LIST_REDUCE_PRODUCT]: reduceProduct,
    [PLAN_LIST_REMOVE_PRODUCT]: removeProduct,
    [PLAN_LIST_CLEAR_PRODUCT]: clearProduct,
    [PLAN_LIST_MODIFY_PRODUCT]: modifyProduct,
    [RESTORE_PLAN_LIST]: initPlanList,
  },
  state.planList
);
